const ComponentDefault = {
    LINE: {
        TYPE_NEXTCOMPONENT: "NextComponent",
        KEY_SUCCESS: "-10",
        TEXT_SUCCESS: "Success",
        KEY_FAIL: "-11",
        TEXT_FAIL: "Fail",
    },
    COMPONENT_NAME: {
        TRIGGER: "Trigger",
        SAVE: "Save",
        DEBUG: "DebugComponent",
    },
    WF_CATEGORY_TEST_COMONENT: 4,

    get LINE_SUCCESS() {
        return {
            key: this.LINE.KEY_SUCCESS,
            lineType: this.LINE.TYPE_NEXTCOMPONENT,
            lineNextFlow: "0",
            lineNextFlowText: "",
            lineText: this.LINE.TEXT_SUCCESS
        };
    },

    get LINE_FAIL() {
        return {
            key: this.LINE.KEY_FAIL,
            lineType: this.LINE.TYPE_NEXTCOMPONENT,
            lineNextFlow: "0",
            lineNextFlowText: "",
            lineText: this.LINE.TEXT_FAIL
        };
    },

    get workflowJson() {
        return {
            "class": "go.GraphLinksModel",
            "copiesArrays": true,
            "copiesArrayObjects": true,
            "linkFromPortIdProperty": "fromPort",
            "linkToPortIdProperty": "toPort",
            "nodeDataArray": [
                {
                    category: "Tigger",
                    loc: "-382.80000001192093 -251.20000076293945",
                    compId: 1,
                    masterComponentkey: "TRIGGER",
                    key: 1,
                    name: "Trigger",
                    displayName: "Trigger",
                    source: "/wf/assets/media/icons/trigger.svg",
                    view: "",
                    data: null,
                    categoryname: "Workflow Elements",
                    categoryId: 1,
                    parent: 1,
                    selectable: false,
                    cursor: "default",
                    leftArray: [{ portId: "left0" }, { portId: "left1" }, { portId: "left2" }, { portId: "left3" }],
                    topArray: [{ portId: "top0" }, { portId: "top1" }, { portId: "top2" }, { portId: "top3" }],
                    bottomArray: [{ portId: "bottom0" }, { portId: "bottom1" }, { portId: "bottom2" }, { portId: "bottom3" }],
                    rightArray: [{ portId: "right0" }, { portId: "right1" }, { portId: "right2" }, { portId: "right3" }],
                    flowStepId: 1
                },
                {
                    category: "Save",
                    loc: "-395.80000001192093 192.79999923706055",
                    compId: 2,
                    masterComponentkey: "SAVE",
                    key: 2,
                    name: "Save",
                    displayName: "Save",
                    source: "/wf/assets/media/icons/end.svg",
                    view: "",
                    data: null,
                    categoryname: "Workflow Elements",
                    categoryId: 1,
                    parent: 1,
                    selectable: false,
                    cursor: "default",
                    leftArray: [{ portId: "left0" }, { portId: "left1" }, { portId: "left2" }, { portId: "left3" }],
                    topArray: [{ portId: "top0" }, { portId: "top1" }, { portId: "top2" }, { portId: "top3" }],
                    bottomArray: [{ portId: "bottom0" }, { portId: "bottom1" }, { portId: "bottom2" }, { portId: "bottom3" }],
                    rightArray: [{ portId: "right0" }, { portId: "right1" }, { portId: "right2" }, { portId: "right3" }],
                    flowStepId: 3
                }
            ],
            "linkDataArray": []
        };
    },
    get debugComponentJson() {
        return {
            "compId": 11,
            "masterComponentkey": "DEBUG",
            "key": 11,
            "name": "DebugComponent",
            "displayName": "DebugComponent",
            "source": "/wf/assets/media/icons/debug.svg",
            "view": "/DebugComponent",
            "data": { "componentSteps": [{ "debugmode": "sp", "spname": "wft_process_test_component_data", "splist": ["wft_process_test_component_data"] }] },
            "categoryname": "Debug Elements",
            "categoryId": 3,
            "parent": 3
        };
    },

    get defaultSearchFields() {
        /* change the 'Index' node value which is actual column name from the table 'wft_instance_metadata'
        Or else other table may be used to search.
        Update column if changed. */
        return [
            { Name: "From", Value: "", DataType: "Date", Index: "created_at", HashRequired: "No", HashPositions: "", isSecured: "" },
            { Name: "To", Value: "", DataType: "Date", Index: "created_at", HashRequired: "No", HashPositions: "", isSecured: "" },
            { Name: "Status", Value: "", DataType: "Text", HashRequired: "No", HashPositions: "", isSecured: "" },
        ]
    }
};

export default ComponentDefault;
